import React, { Component, PropTypes } from 'react'
import Form from "react-jsonschema-form"
import Job from '../../components/Job'
import JobNew from '../../components/JobNew'
import JobSorter from '../../components/JobSorter'
import classNames from 'classnames'
import {Link} from 'react-router'
import * as _ from 'lodash'
import { statuses, base } from '../../../config'
import { objCleaner } from '../../helpers'
import moment from 'moment'
import StatusAll from './StatusAll'
import StatusBoard from './StatusBoard'
import StatusCarousels from './StatusCarousels'
import PlaceHolderMessage from '../../components/PlaceHolderMessage'

import './Jobs.scss'
import Toggle from 'react-toggle'

export class Jobs extends Component {

    constructor(props) {
        super(props);
        this.state = {
          view: 'carousels',
          filter: ['quote', 'confirmed', 'invoiced', 'paid'],
          tab: 0,
          jobs: [],
          newJob: null,
          moving: null,
          startDate: new Date(moment().startOf('month').subtract(1, 'days').format('YYYY-MM-DD')).toISOString(),
          endDate:  new Date(moment().startOf('month').add('months', 1).format('YYYY-MM-DD')).toISOString()
        }
    }

    componentDidMount () {
      this.ref = base.syncState(`user_details/${this.props.uid}/jobs`, {
          context: this,
          state: 'jobs',
          asArray: true,
          keepKeys: true,
          queries: {
            orderByChild: 'start',
            startAt: this.state.startDate,
            endAt: this.state.endDate
          }
      })
    }

    _getJobs () {
      this.ref = base.syncState(`user_details/${this.props.uid}/jobs`, {
          context: this,
          state: 'jobs',
          asArray: true,
          keepKeys: true,
          queries: {
            orderByChild: 'start',
            startAt: this.state.startDate,
            endAt: this.state.endDate
          }
      })
    }

    _newJob () {
      this.setState({
        newJob: !this.state.newJob
      })
    }

    _filter (filter, check) {
      let filteredAry = []
      if (check) filteredAry = this.state.filter.filter(function(e) { return e !== filter })
      if (!check) {
        let fil = this.state.filter
        fil.push(filter)
        filteredAry = fil
      }
      this.setState({filter: filteredAry})
    }

    setCurrent (moving) {
      this.setState({moving})
    }

    _view (view) {
      this.setState({view})
    }

    onStartChange (startDate, endDate) {
      this.setState({startDate, endDate})
      setTimeout(() => {this._getJobs()}, 5)
    }

    onEndChange (endDate) {
      // this.setState((state) => ({endDate: moment(new Date(endDate)).format("YYYY-MM-DD")}))
      // setTimeout(() => {this._getJobs()}, 5)
    }

    render() {

        let jobs = this.state.jobs
        if (this.state.filter !== 'all') jobs = jobs.filter((job) => {if (this.state.filter.includes(job.selected_status.value)) return job})
        jobs = jobs.sort((d1, d2) => new Date(d1.start).getTime() - new Date(d2.start).getTime());

        const cost = jobs.map(item => {return item.total.cost}).reduce((a, b) => Number(a) + Number(b), 0)
        const sale = jobs.map(item => {return item.total.sale}).reduce((a, b) => Number(a) + Number(b), 0)
        const profit = sale - cost

        return (
          <div className="jobs-page with-sidebar main-pt full-width-page">

            <div className='row'>

              <div className="col-sm-4 col-md-3 ">

                {this.state.newJob &&
                  <div className="m-b-lg">
                    <JobNew
                      uid={this.props.uid}
                      sheets={this.props.sheets}
                      newJob={this._newJob.bind(this)}
                      history={this.props.history}
                    />
                  </div>
                }

                <JobSorter
                  _newJob={this._newJob.bind(this)}
                  _view={this._view.bind(this)}
                  view={this.state.view}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onStartChange={this.onStartChange.bind(this)}
                  onEndChange={this.onEndChange.bind(this)}
                  _filter={this._filter.bind(this)}
                  filter={this.state.filter}
                  profit={profit}
                  cost={cost}
                  sale={sale}
                  monthFilter
                  showFilter
                  jobNew={this.state.newJob}
                />
              </div>

              <div className='col-sm-8 col-md-9'>

                {this.state.jobs.length == 0 && <PlaceHolderMessage user={this.props.user} /> }

                <div className='row hidden'>
                  <div className='col-sm-6'>
                    <h4 className='m-t-0 m-b-lg'>Job Carousels</h4>
                  </div>
                  <div className='col-sm-6 text-right'>
                    <Toggle
                      icons={{
                        checked: <i className="glyphicon glyphicon-dashboard"></i>,
                        unchecked: null,
                      }}
                      defaultChecked={this.state.view === 'carousels'}
                      onChange={this.handleSoupChange}
                     />
                  </div>
                </div>

                {this.state.view === 'grid' &&
                  <StatusAll
                    uid={this.props.uid}
                    statuses={statuses}
                    jobs={jobs}
                  />
                }

                {this.state.view === 'carousels' &&
                  <StatusCarousels
                    uid={this.props.uid}
                    statuses={statuses}
                    jobs={jobs}
                    history={this.props.history}
                  />
                }

                {this.state.view === 'board' &&
                  <StatusBoard
                    uid={this.props.uid}
                    statuses={statuses}
                    jobs={jobs}
                  />
                }

              </div>

            </div>

          </div>
        )
    }
}

//<button className='btn btn-block btn-success' onClick={this._new.bind(this)}>New</button>

//<SheetNew uid={this.props.uid} history={this.props.history} />

//label={<CustomizedLabel />}

//<Tooltip/>

// function mapStateToProps (state, ownProps) {
//   return {
//     sheets: state.finance.sheets
//   }
// }
//
// const mapDispatchToProps = (dispatch, ownProps) => {
//   return {
//     resetSheet: () => {
//       dispatch(resetSheet())
//     },
//     setSheet: (sheet) => {
//       dispatch(setSheet(sheet))
//     }
//   }
// }

export default Jobs



// WEBPACK FOOTER //
// ./src/views/pages/Jobs/index.js